export default defineNuxtRouteMiddleware((to, from) => {
  const staticFilePattern = /\.(js|css|png|jpg|jpeg|gif|svg|webp|ico|woff|woff2|eot|ttf|otf|json|php|txt|xml|\.env)$/;

  if (staticFilePattern.test(to.path)) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Not Found',
    });
  }
});
